export default __webpack_public_path__ + "static/media/alur-1.83be7b86.png";